"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersperse = void 0;
/**
 * Creates a copy of `subject` with an instance of `separator` _between_ each element of `subject`.
 *
 * @example
 * intersperse([1, 2, 3], 0) // returns [1, 0, 2, 0, 3]
 *
 * @example
 * intersperse([], 0) // returns []
 *
 * @example
 * intersperse([1], 0) // returns [1]
 */
function intersperse(subject, separator) {
    return subject.map((elem, i, arr) => (i < arr.length - 1 ? [elem, separator] : [elem])).flat(1);
}
exports.intersperse = intersperse;
//# sourceMappingURL=#intersperse.js.map